import React from 'react';
import { Box, Typography } from '@mui/material';

interface PreChatHeaderProps {
    icon: React.ReactNode | string;
    iconAlt: string;
    title: string;
    description: string;
    instructions?: string;
    additionalInfo?: string;
}

export const PreChatHeader: React.FC<PreChatHeaderProps> = ({
    icon,
    iconAlt,
    title,
    description,
    instructions,
    additionalInfo
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2.5,
                width: '100%',
            }}
        >
            {typeof icon === "string" ? (
            <Box
                sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    bgcolor: 'background.paper',
                    border: 1,
                    borderColor: 'divider',
                    boxShadow: '0 2px 0 rgba(47,59,70,0.05)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <img
                    src={icon}
                    alt={iconAlt}
                    style={{ width: 28, height: 28, flexShrink: 0 }}
                />
                </Box>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        width: { xs: 48, lg: 56 },
                        height: { xs: 48, lg: 56 },
                        justifyContent: "center",
                        alignItems: "center",
                        bgcolor: "grey.50",
                        color: "custom.brandTeal",
                        borderRadius: "12px",
                        border: "1px solid #EBEFF580",
                    }}
                    >
                    {icon}
                </Box>
            )}
           
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    maxWidth: '56.25rem',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1.5,
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        color: 'text.primary',
                        textAlign: 'center',
                        fontWeight: 800,
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="subtitle2"
                    sx={{
                        alignSelf: 'stretch',
                        color: 'text.secondary',
                        textAlign: 'center',
                        fontWeight: 400,
                        lineHeight: 1.5,
                    }}
                >
                    {description}
                </Typography>
                {instructions && (
                    <Typography
                        variant="body1"
                        sx={{
                            alignSelf: 'stretch',
                            color: 'text.secondary',
                            textAlign: 'center',
                            lineHeight: 1.5,
                        }}
                    >
                        {instructions}
                    </Typography>
                )}
                {additionalInfo && (
                    <Typography
                        variant="body1"
                        sx={{
                            alignSelf: 'stretch',
                            color: 'text.secondary',
                            textAlign: 'center',
                            lineHeight: 1.5,
                        }}
                    >
                        {additionalInfo}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default PreChatHeader;
